<!--
 * @Author: your name
 * @Date: 2021-04-26 18:00:26
 * @LastEditTime: 2021-04-27 09:24:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/business/rebates/index.vue
-->
<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="list">最终返点列表</el-menu-item>
        </el-menu>
      </div>
      <div class="content-wrap">
        <rebatesList v-if="activeIndex == 'list'"></rebatesList>
      </div>
    </div>
  </div>
</template>

<script>
import rebatesList from "./component/list";
export default {
  data() {
    return {
      activeIndex: "list",
    };
  },
  components: {
    rebatesList,
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex = key;
    },
    dealToDeliveryList() {
      this.activeIndex = 'list';
    }
  }
}
</script>